function getCssVarValue(varName) {
    return getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
}
export { getCssVarValue };
